module.exports = __webpack_public_path__ + "media/assets/ClickedWrongX-83f43bc197ba809da5fafe1a35540d35.svg";